import styles from './SuggestedImprovement.module.scss';

interface SuggestedImprovementProps {
  suggestedImprovement: string;
}

function SuggestedImprovement({
  suggestedImprovement,
}: SuggestedImprovementProps) {
  return (
    <div className={styles.suggestedImprovementContainer}>
      <p
        dangerouslySetInnerHTML={{
          __html: suggestedImprovement,
        }}
      />
    </div>
  );
}

export default SuggestedImprovement;
